<template>
    <modal :show="show" :showLarge="step === 4">
        <div slot="modalHeader">
          <modal-header v-if="!(step > 2 && step < 3)" :closeModal="customClose">{{ title }}</modal-header>
          <modal-header v-else :closeModal="customClose">Import After Effects Project</modal-header>
        </div>
        <spinner-icon v-if="loading" />
        <notifications :messages="notifications" v-if="notifications && notifications.length > 0"/>
        <steps v-if="!((step > 2 && step < 3) && newCreative.type === 'after-effects')" :options="steps.options" :active="step" />
        <div v-if="step === 1">
          <form-group>
            <field name="Name" value="" v-model="newCampaign.name" :error="errors.campaignName"/>
          </form-group>
          <form-group>
            <field name="Campaign Job Number (Optional)" value="" v-model="newCampaign.campaign_job_number"/>
          </form-group>
          <form-group>
            <dropdown name="Client" :options="clientOptions" v-model="newCampaign.client" :current="newCampaign.client"/>
          </form-group>
        </div>
        <div v-else-if="step === 2">
          <form-group>
            <field name="Name" value="" v-model="newCreative.name" :error="errors.creativeName"/>
          </form-group>
          <form-group>
            <field name="Creative Job Number (Optional)" value="" v-model="newCreative.creative_job_number" />
          </form-group>
          <form-group>
            <dropdown name="Type" :options="creativeOptions" v-model="newCreative.type" current="html" @input="creativeSelect()"/>
            <div v-if="newCreative.type === 'after-effects'" class="text-danger"><br />Uploading AEPX files will enable error checking within the upload process.</div>
          </form-group>
          <upload-file name="Master File" :ctaText="uploadText" @input="onUploadFile" acceptedFileType="" :error="errors.creativeFile" />
          <br />
<!--          <upload-file v-if="newCreative.type === 'after-effects'" @input="onUploadConfig" name="Config" :ctaText="uploadConfig" acceptedFileType="application/csv/json/xml" :error="errors.creativeFile" />-->
<!--          <br />-->

        </div>
        <div v-else-if="(step > 2 && step < 3) && newCreative.type === 'after-effects'">
          <div>
            <p>Step {{subStep}} of 4 </p>
            <p>{{subStepText}}</p>
          </div>
          <div v-if="step === 2.1">
            <form-group class="composition-block">
              <field name="Add composition names" v-model="composition" :error="errors.compositions"/>
              <button-cta :onClick="addComposition" :class="[errors.compositions !== '' ? 'margin-auto' : '']">Add</button-cta>
            </form-group>
            <div
            v-if="compositions.length > 0"
            class="listing-wrapper">
            <div
            class="step-listing"
            v-for="(composition, itr) in compositions" :key="itr">
            <field v-if="compositionEditing === itr" v-model="compositions[itr]" :error="errors.compositions"/>
            <p v-else>{{composition}}</p>
            <div>
              <button-cta v-if="compositionEditing === itr" class="btn-xs btn btn-success" :onClick="() => stopEditingComposition(itr)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button-cta>
              <button-cta v-else-if="compositionEditing === null" class="btn-xs btn btn-primary" :onClick="() => editComposition(itr)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button-cta>
              <button-cta class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteComposition(itr)">
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button-cta>
            </div>
          </div>
        </div>
        <upload-file v-if="newCreative.type === 'after-effects'" @input="onUploadConfig" name="Config Json File" :ctaText="uploadConfig" acceptedFileType="application/csv/json/xml" :error="errors.creativeFile" />
      </div>
<!--          <div v-else-if="step === 2.2">-->
<!--            <form-group>-->
<!--              <div>-->
<!--                <dropdown :current="encodingProfilesOptions()[0].name" name="Default and saved profiles" :options="encodingProfilesOptions()" v-model="newEncodingProfile"/>-->
<!--                <span v-if="errors.encodingProfiles" class="text-danger">{{ errors.encodingProfiles}}</span>-->
<!--              </div>-->
<!--              <button-cta class="buttun-margin" :onClick="addEncodingProfile">Add</button-cta>-->
<!--            </form-group>-->
<!--            <div v-if="selectedEncodingProfiles.length > 0" class="listing-wrapper" >-->
<!--              <div class="step-listing" v-for="(selectedEncodingProfile, itr) in selectedEncodingProfiles" :key="itr">-->
<!--                <p>{{selectedEncodingProfile}}</p>-->
<!--                <button-cta class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteEncodingProfile(itr)">-->
<!--                  <i class="fa fa-trash" aria-hidden="true"></i>-->
<!--                </button-cta>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div v-else-if="step === 2.2">
            <form-group class="variable-element-wrapper">
              <!-- <dropdown name="Compositions" :options="compositionsOptions()" v-model="composition"/> -->
              <div class="d-flex variable-element composition-block">
                <field name="Layer name in your comps" placeholder="Headline 1" v-model="layerName" />
                <field name="Add Default Text or Filename" placeholder="Default Value" v-model="layerValue" />
                <dropdown :current="layerTypesOptions()[0].name" name="Type" :options="layerTypesOptions()" v-model="layerType" />
                <button-cta class="buttun-margin" :onClick="addLayer">Add</button-cta>
              </div>
              <span v-if="errors.layers" class="text-danger">{{ errors.layers}}</span>
            </form-group>
            <div>
              <table class="table no-bordered">
                <tbody>
                  <tr v-for="(layer, itr) in layers" :key="itr">
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <field placeholder="Headline 12" v-model="layers[itr].name" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.name" /></td>
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <field placeholder="Default Value" v-model="layers[itr].value" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.value" /></td>
                    <td :style="{width: '30%'}" v-if="layerEditing === itr">
                      <dropdown :options="layerTypesOptions()" :current="capitalize(layer.type)" v-model="layers[itr].type" />
                    </td>
                    <td :style="{width: '30%'}" v-else><field placeholder="Headline 12" disabled v-model="layer.type" /></td>
                    <td align="right" :style="{display: 'flex',width: '30%'}">
                      <button-cta :style="{marginTop: '0.5rem'}" v-if="layerEditing === itr" class="btn-xs btn btn-success" :onClick="() => stopEditingLayer(itr)">
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </button-cta>
                      <button-cta :style="{marginTop: '0.5rem'}" v-else-if="layerEditing === null" class="btn-xs btn btn-primary" :onClick="() => editlayer(itr)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button-cta>
                      <button-cta :style="{marginTop: '0.5rem', marginInline: '0.1rem'}" class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteLayer(itr)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button-cta>
                    </td>
                  </tr>
                </tbody>
              </table>
              <upload-file v-if="newCreative.type === 'after-effects'" @input="onUploadlayer" name="Layer Json File" :ctaText="uploadLayer" acceptedFileType="application/csv/json/xml" :error="errors.creativeFile" />
            </div>
          </div>
          <div v-else-if="step === 2.3">
<!--            <form-group>-->
<!--              <div class="composition-block">-->
<!--                <dropdown name="Existing plugins" :options="pluginsOptions()" :all-disabled="true" v-model="plugin" />-->
<!--                 <button-cta :onClick="addPlugin">Add</button-cta> -->
<!--              </div>-->
<!--              <span v-if="errors.plugins" class="text-danger">{{ errors.plugins}}</span>-->
<!--            </form-group>-->
<!--            <form-group>-->
<!--              <div class="composition-block">-->
<!--                <dropdown name="Existing fonts" :options="fontsOptions()" :all-disabled="true" v-model="font" />-->
<!--                 <button-cta :onClick="addFont">Add</button-cta> -->
<!--              </div>-->
<!--              <span v-if="errors.fonts" class="text-danger">{{ errors.fonts}}</span>-->
<!--            </form-group>-->
            <span>If this project requires any plugins or fonts that have not been previously supplied to us, please contact us at <a href="mailto:techsupport@otomo.io">techsupport@otomo.io</a></span>
            <!-- <form-group class="composition-block">
              <field name="Request other plugins to be install on your project" placeholder="Add plugin name and version here" v-model="reqPlugin" />
              <button-cta :onClick="requestPlugin">Request</button-cta>
            </form-group> -->
            <!-- <div v-if="selectedPlugins.length > 0" class="listing-wrapper">
              <span>Selected Plugins</span><br/>
              <div class="step-listing"  v-for="(plugin, itr) in selectedPlugins" :key="itr">
                <p>{{plugin}}</p>
                <button-cta class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deletePlugin(itr)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
              </div>
            </div>
            <div v-if="selectedFonts.length > 0" class="listing-wrapper">
              <span>Selected Fonts</span><br/>
              <div class="step-listing" v-for="(sFont, itr) in selectedFonts" :key="itr">
                <p>{{sFont}}</p>
                <button-cta class="btn btn-danger btn-xs btn btn-primary" :onClick="() => deleteFont(itr)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
              </div>
            </div> -->
          </div>
          <div v-else-if="step === 2.4">
            <div class="text-center analysing-files"><p>
              Analysing your files
            </p>
            </div>
          </div>
        </div>
        <div v-else-if="step === 3 && newCreative.type === 'after-effects'">
          <label v-if="this.masterFileExtension === '.aep'">Upload your Adobe After Effects footage here.</label>
          <label v-else>Upload your Adobe After Effects footage here or select next to upload later.</label>
          <div>
            <div v-if="this.masterFileExtension === '.aep'">
              <label><small>Firstly, please select the exact name of your footage folder within your Adobe After Effects project:</small></label>
              <dropdown :options="footageOptions()" :current="'(Footage)'" v-model="footageStructure"/>
              <br>
            </div>
            <upload-file icon="upload" ctaText="Upload Footage Folder" @input="saveFootage" acceptedFileType="application/zip"/>
            <br>
            <div v-if="this.masterFileExtension === '.aep'">
              <small>Upload your zipped footage folder here.</small>
              <small>The folder should be zipped (not the contents of folder).<br />(Max total file size 2GB.</small>
              <small>If your zipped footage folder is over 2GB please remove some footage and you can upload that separately into the footage folder after this initial setup process.)</small>
            </div>
            <div v-else>
              <small>Upload the zipped contents of your footage folder here. (Max file 2GB, multiple uploads allowed)</small>
            </div>
          </div>
        </div>
        <div v-else-if="step === 4 && formattedCreative">
          <creative-table :tableData="formattedCreative.fields" v-model="formattedCreative.fields" @onToggleParentCheckboxes="updateCheckboxData" :type="newCreative.type" />
        </div>
        <div slot="modalFooter">
          <modal-footer :hide-confirm-text="step === 2.4" :closeModal="customClose" :confirm="save" :back="back" :showBack="showBack()" :hideCancelText="(step !== 1 && step !== 2)" :confirmText="step === 4 ? 'Complete' : 'Next'"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Steps from '@/components/Steps/steps'
import UploadFile from '@/components/UploadFile/upload-file'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import Notifications from '@/components/Notifications/notifications'
import CreativeTable from '@/components/CreativeTable/creative-table'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'

import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {assetMixin} from '@/mixins/assetMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'
import {pluginMixin} from '@/mixins/pluginMixin'
import {fontMixin} from '@/mixins/fontMixin'

import {omit, map, assoc} from 'ramda'
import {profileMixin} from '@/mixins/profileMixin'

export default {
  name: 'modal_create_campaign',
  mixins: [profileMixin, modalMixin, campaignMixin, creativeMixin, notificationMixin, assetMixin, encodingProfileMixin, pluginMixin, fontMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    Steps,
    FormGroup,
    Dropdown,
    Field,
    UploadFile,
    Heading,
    CreativeTable,
    Notifications,
    SpinnerIcon
  },
  props: {
    // clientOptions: Array,
    show: Boolean,
    goToStep: {
      type: Number,
      default: 1
    },
    confirmId: String
  },
  data: () => ({
    step: 0,
    subStep: 0,
    compositionIsEditing: null,
    layerIsEditing: null,
    uploadText: 'Upload',
    uploadZip: 'uploadZip',
    files: null,
    zip: null,
    table: {
      columns: {
        isEditable: 'allCheckboxes',
        name: 'Name',
        type: 'Type',
        charLimit: 'Limit',
        isCharLimitHard: 'HardLimit',
        defaultValue: 'Default Value'
      }
    },
    newCampaign: {
      name: '',
      client: '',
      campaign_job_number: ''
    },
    newCreative: {
      name: '',
      type: 'html',
      creative_job_number: ''
    },
    creativeOptions: [
      {
        name: 'HTML',
        value: 'html'
      },
      {
        name: 'PSD',
        value: 'psd'
      },
      {
        name: 'VIDEO (HTML)',
        value: 'html-video'
      },
      {
        name: 'After Effects',
        value: 'after-effects'
      }
    ],
    errors: {
      campaignName: '',
      creativeName: '',
      creativeFile: '',
      compositions: '',
      encodingProfiles: '',
      layers: '',
      plugins: '',
      fonts: ''
    },
    footageStructure: '(Footage)',
    disabled: true,
    subStepText: 'Please enter the names of the compositions that you would like to edit and render.',
    compositions: [],
    composition: '',
    selectedEncodingProfiles: [],
    newEncodingProfile: 'default',
    layers: [],
    layerName: '',
    layerValue: '',
    layerType: 'text',
    plugin: '',
    selectedPlugins: [],
    reqPlugin: '',
    font: '',
    selectedFonts: [],
    reqFont: '',
    masterFileExtension: ''
  }),
  mounted () {
    this.step = this.goToStep
    this.newCampaign.client = this.currentClient
    if (!this.isAeAllowed) {
      this.creativeOptions = this.creativeOptions.filter(opt => opt.value !== 'after-effects')
    }
  },
  watch: {
    goToStep: function () {
      this.step = this.goToStep
    },
    step: function () {
      switch (this.step) {
        case 2.1:
          this.subStepText = 'Please enter the names of the compositions that you would like to edit and render.'
          break
        case 2.2:
          this.subStepText = 'Set Layer Names.'
          break
        case 2.3:
          this.subStepText = 'Plugins & Fonts'
          break
        case 2.4:
          this.subStepText = 'Analysing your files'
          break
      }
    }
  },
  computed: {
    compositionEditing () {
      return this.compositionIsEditing
    },
    layerEditing () {
      return this.layerIsEditing
    },
    title () {
      return `Create ${this.step === 1 ? 'Campaign' : 'Creative'}`
    },
    currentClient () {
      return this.$route.params.id
    },
    isAeAllowed () {
      return this.profileUser && this.profileUser.isAeAllowed === 1
    },
    is_rm_allowed () {
      return this.profileUser && this.profileUser.is_rm_allowed === 1
    },
    formattedCreative () {
      const newCreative = this.creative
      newCreative.fields = map(item => assoc('editableActions', true, item), this.creative.fields)
      return newCreative
    }
  },
  methods: {
    creativeSelect (e) {
      this.checkFilesType(this.files)
    },
    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    onUploadFile (e) {
      this.uploadText = 'Upload'
      this.errors.creativeFile = ''
      const files = e.target.files || e.dataTransfer.files
      if (!this.checkFilesType(files)) {
        return
      }
      this.uploadText = e.target.files[0].name
      this.files = files
    },
    checkFilesType (files) {
      this.errors.creativeFile = ''
      if (files && files.length > 0) {
        if (!this.validateFile(files[0])) {
          this.errors.creativeFile = this.newCreative.type === 'after-effects' ? `Only AEPX and AEP files are allowed.` : `Only Zip files are allowed.`
          return false
        }
      }
      return true
    },
    validateFile (file) {
      const allowedExtensions = this.newCreative.type === 'after-effects' ? ['.aep', '.aepx'] : ['.zip']
      this.masterFileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
      return allowedExtensions.includes(this.masterFileExtension)
    },
    onUploadZip (e) {
      const files = e.target.files || e.dataTransfer.files
      this.uploadZip = e.target.files[0].name
      this.zip = files
    },
    onUploadConfig (e) {
      const config = e.target.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        const configObj = JSON.parse(e.target.result)
        configObj.compositions.forEach(composition => {
          // ignore duplicates
          if (!this.compositions.includes(composition)) {
            this.compositions.push(composition)
          }
        })
      }
      fileReader.readAsText(config)
    },
    onUploadlayer (e) {
      const layerFile = e.target.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        const layerObj = JSON.parse(e.target.result)
        // const otomoLayers = Object.values(layerObj)[0]
        for (const layerAndKeys of Object.entries(layerObj)) {
          if (layerAndKeys[0] === 'otomo-layers') {
            for (const [key, layer] of Object.entries(layerAndKeys[1])) {
              const newLayer = {name: key, value: layer.defaultValue, type: layer.type}
              if (!this.isLayerExists(newLayer)) {
                this.layers.push(newLayer)
              }
            }
          }
        }
      }
      fileReader.readAsText(layerFile)
    },
    save () {
      this.resetNotifications()
      this.resetErrors()
      this.layerIsEditing = null
      this.compositionIsEditing = null

      if (this.step === 1) {
        this.saveCampaign()
      }
      if (this.step === 2) {
        if (!this.checkFilesType(this.files)) {
          return
        }
        if (this.newCreative.type === 'after-effects') {
          this.saveCreative(true)
          if (!this.steps.options.includes('Footage Library')) {
            this.steps.options.splice(2, 0, 'Footage Library')
          }
          return
        } else {
          this.saveCreative()
        }
      }
      if (this.step === 2.1) {
        this.resetErrors()
        if (!this.compositions.length) {
          this.errors.compositions = 'This value should not be blank.'
          return
        }
        this.subStepText = 'Set Layer Names.'
        this.step = 2.2
        this.subStep = 2
        return
      }
      if (this.step === 2.2) {
        this.resetErrors()
        if (!this.layers.length) {
          this.errors.layers = 'This value should not be blank.'
          return
        }
        // if (!this.composition) {
        //   this.errors.layers = 'Composition value should not be blank.'
        //   return
        // }
        this.subStepText = 'Plugins & Fonts'
        this.step = 2.3
        this.subStep = 3
        // this.startLoading()
        // this.getPlugins().then(() => {
        //   this.getFonts().then(() => {
        //     this.step = 2.4
        //     this.subStep = 4
        //     this.finishLoading()
        //   }, error => {
        //     this.finishLoading()
        //     this.addNotification('danger', error)
        //   })
        // }, error => {
        //   this.addNotification('danger', error)
        // })
        return
      }
      if (this.step === 2.3) {
        this.resetErrors()
        this.subStepText = 'Analysing your files'
        this.step = 2.4
        this.subStep = 4
        this.saveCreative(true, 1)
        return
      }
      if (this.step === 3) {
        this.skipFootage()
      }
      if (this.step === 4) {
        this.completeCreative('complete')
      }
    },
    saveCampaign () {
      if (this.newCampaign.name === '') {
        this.errors.campaignName = 'This value should not be blank.'
        return
      }
      this.addCampaign(this.newCampaign).then(() => {
        this.step = 2
      }, error => {
        this.finishLoading()
        this.close()
        this.addNotification('danger', error)
      })
    },
    resetErrors () {
      this.errors.campaignName = ''
      this.errors.creativeName = ''
      this.errors.creativeFile = ''
      this.errors.compositions = ''
      this.errors.encodingProfiles = ''
      this.errors.layers = ''
      this.errors.plugins = ''
      this.errors.fonts = ''
    },
    saveCreative (ae = false, aeStep = 0) {
      let creativeErrors = 0

      this.resetErrors()

      if (this.newCreative.name === '') {
        this.errors.creativeName = 'This value should not be blank.'
        creativeErrors++
      }
      if (!this.files) {
        this.errors.creativeFile = 'You need to upload a master file.'
        creativeErrors++
      }

      if (creativeErrors) {
        return
      }

      if (ae && !aeStep) {
        this.step = 2.1
        this.subStep = 1
        return
      }

      this.startLoading()
      const formData = new FormData()
      formData.append('name', this.newCreative.name)
      formData.append('type', this.newCreative.type)
      formData.append('creative_job_number', this.newCreative.creative_job_number)
      formData.append('campaign', this.campaign.hash_id)
      formData.append('file', this.files[0])

      if (ae && aeStep) {
        formData.append('compositions', JSON.stringify(this.compositions))
        formData.append('composition', this.compositions[0])
        formData.append('encoding_profiles', JSON.stringify(this.selectedEncodingProfiles))
        formData.append('layers', JSON.stringify(this.layers))
        formData.append('plugins', JSON.stringify(this.selectedPlugins))
        formData.append('fonts', JSON.stringify(this.selectedFonts))
      }

      this.addCreative(formData).then((creative) => {
        const masters = {}
        const payload = {
          id: creative.hash_id,
          columns: ['id', 'master', 'locale', 'width', 'height'],
          unit: [],
          index6: true
        }
        creative.masters.forEach(master => {
          masters[master.name] = {
            values: [this.uniqueId(), master.name, master.name, master.width, master.height]
          }
        })
        creative.fields.forEach(field => {
          payload.columns.push(field.name)
          for (const master in masters) {
            let value = ''
            if (field.default_values !== null) {
              field.default_values.forEach(defaultValue => {
                if (defaultValue.master === master) {
                  value = defaultValue.value
                }
              })
            }
            if (this.newCreative.type === 'after-effects') {
              value = field.defaultValue
            }
            masters[master].values.push(value)
          }
        })
        for (const master in masters) {
          payload.unit.push(masters[master].values)
        }
        this.updateCreativeUnit(payload).then(() => {
          if (this.newCreative.type === 'after-effects') {
            // this.step = 2.1
            // this.subStep = 1
            this.step = 3
          } else {
            this.step = 4
          }
          this.addNotification('success', 'Creative successfully created.')
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        console.log(error)
        if (error.includes('Composition Error')) {
          this.step = 2.1
          this.subStep = 1
        } else if (error.includes('Layer Error')) {
          this.step = 2.2
          this.subStep = 2
        }
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    skipFootage () {
      this.startLoading()
      this.getCreativeUnits(this.creative.hash_id).then(() => {
        this.step = 4
        this.finishLoading()
      })
    },
    saveFootage (e) {
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      Object.keys(files).forEach((key) => {
        formData.append('file' + key, files[key])
        formData.append('footage', this.footageStructure)
        formData.append('isEditing', false)
      })
      const data = {
        id: this.creative.hash_id,
        file: formData
      }
      this.uploadFootage(data).then((response) => {
        this.step = 4
        this.finishLoading()
        this.showAssetNotification = true
        this.dataLoaded = 'video'
        this.addNotification('success', response.status)
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    completeCreative (action) {
      this.startLoading()
      const updateCreative = omit(['campaign', 'date_created', 'date_updated', 'type', 'units', 'editableActions'], this.formattedCreative)
      this.updateCreative(updateCreative).then(() => {
        if (action === 'complete') {
          this.$router.push(`/creatives/${updateCreative.hash_id}/bulk`)
        } else {
          this.$router.push(`/creatives/${updateCreative.hash_id}/bulk`) // TODO Push to current page
        }
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    },
    customClose () {
      if (this.step === 4) {
        this.completeCreative('close')
      } else {
        this.close()
      }
    },
    footageOptions () {
      this.disabled = false
      const optionsArray = []
      let data = [
        'footage',
        '(Footage)',
        '_footage',
        'Footage'
      ]

      data.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    encodingProfilesOptions () {
      let optionsArray = []
      let idsToSearch = this.campaign.client.encoding_profiles
      this.encodingProfiles.forEach(ep => {
        if (idsToSearch.includes(ep.id)) {
          const data = {
            name: ep.name,
            value: ep.name
          }
          optionsArray.push(data)
        }
      })
      return optionsArray
    },
    addComposition () {
      this.resetErrors()
      let existingValue = this.compositions.find(item => item === this.composition)
      if (existingValue) {
        this.errors.compositions = 'No Duplicates Compositions allowed'
        return
      }
      if (this.composition == null || this.composition === '') {
        this.errors.compositions = 'This value should not be blank.'
        return
      }
      this.compositions.push(this.composition)
      this.composition = null
    },
    editComposition (itr) {
      this.compositionIsEditing = itr
    },
    stopEditingComposition (itr) {
      if (this.compositions[itr] == null || this.compositions[itr] === '') {
        this.errors.compositions = 'This value should not be blank.'
        return
      }
      let itemsCount = this.compositions.length
      let otherCompositions = this.compositions.filter(item => item !== this.compositions[itr])
      if (itemsCount - 1 !== otherCompositions.length) {
        this.errors.compositions = 'No Duplicates Composition Names allowed'
        return
      }
      this.resetErrors()
      this.compositionIsEditing = null
    },
    deleteComposition (itr) {
      this.compositions = this.compositions.filter((o, i) => itr !== i)
    },
    addEncodingProfile () {
      this.resetErrors()
      let existingValue = this.selectedEncodingProfiles.find(item => item === this.newEncodingProfile)
      if (existingValue) {
        this.errors.encodingProfiles = 'No Duplicates Encoding Profiles allowed'
        return
      }
      this.selectedEncodingProfiles.push(this.newEncodingProfile)
    },
    deleteEncodingProfile (itr) {
      this.selectedEncodingProfiles = this.selectedEncodingProfiles.filter((o, i) => itr !== i)
    },
    compositionsOptions () {
      const optionsArray = []
      this.compositions.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    layerTypesOptions () {
      const optionsArray = []
      let data = [
        'Text',
        'Image',
        'Video',
        'Audio'
      ]
      data.forEach((d) => {
        const option = {
          name: d,
          value: d
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    pluginsOptions () {
      const optionsArray = []
      this.plugins.forEach((d) => {
        const option = {
          name: d.name,
          value: d.name
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    fontsOptions () {
      const optionsArray = []
      this.fonts.forEach((d) => {
        const option = {
          name: d.name,
          value: d.name
        }
        optionsArray.push(option)
      })
      return optionsArray
    },
    addLayer () {
      this.resetErrors()
      if (!this.layerName) {
        this.errors.layers = 'Layer Name should not be blank.'
        return
      }
      if (!this.layerValue) {
        this.errors.layers = 'Layer Value should not be blank.'
        return
      }
      if (!this.layerType) {
        this.errors.layers = 'Layer Type should not be blank.'
        return
      }
      let existingValue = this.layers.find(item => item.name === this.layerName)
      if (existingValue) {
        this.errors.layers = 'No Duplicates Layer Name allowed'
        return
      }
      let newLayer = {
        name: this.layerName,
        value: this.layerValue,
        type: this.layerType
      }
      this.layers.push(newLayer)
      this.layerName = null
      this.layerValue = null
    },
    editlayer (itr) {
      this.layerIsEditing = itr
    },
    stopEditingLayer (itr) {
      let otherLayers = this.layers.filter(item => item !== this.layers[itr])
      let existingValue = otherLayers.find(item => item.name === this.layers[itr].name)
      if (existingValue) {
        this.errors.layers = 'No Duplicates Layer Name allowed'
        return
      }
      if (!this.layers[itr].name) {
        this.errors.layers = 'Layer Name should not be blank.'
        return
      }
      if (!this.layers[itr].value) {
        this.errors.layers = 'Layer Value should not be blank.'
        return
      }
      if (!this.layers[itr].type) {
        this.errors.layers = 'Layer Type should not be blank.'
        return
      }
      this.resetErrors()
      this.layerIsEditing = null
    },
    deleteLayer (itr) {
      this.layers = this.layers.filter((o, i) => itr !== i)
    },
    isLayerExists (layer) {
      return this.layers.find(item => item.name === layer.name && item.value === layer.value && item.type === layer.type)
    },
    addPlugin () {
      this.resetErrors()
      if (!this.plugin) {
        this.errors.plugins = 'This value should not be blank.'
        return
      }
      let existingValue = this.selectedPlugins.find(item => item === this.plugin)
      if (existingValue) {
        this.errors.plugins = 'No Duplicates Plugins allowed'
        return
      }
      this.selectedPlugins.push(this.plugin)
    },
    deletePlugin (itr) {
      this.selectedPlugins = this.selectedPlugins.filter((o, i) => itr !== i)
    },
    requestPlugin () {
      if (!this.reqPlugin || this.reqPlugin === '') {
        this.errors.plugins = 'Request Plugin Name cannot be empty'
        return
      }
      this.startLoading()
      let data = {
        name: this.reqPlugin
      }
      this.addSinglePlugin(data).then((response) => {
        this.reqPlugin = null
        this.finishLoading()
        this.addNotification('success', 'Request Submitted Successfully')
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    addFont () {
      this.resetErrors()
      if (!this.font) {
        this.errors.fonts = 'This value should not be blank.'
        return
      }
      let existingValue = this.selectedFonts.find(item => item === this.font)
      if (existingValue) {
        this.errors.fonts = 'No Duplicates Fonts allowed'
        return
      }
      this.selectedFonts.push(this.font)
    },
    deleteFont (itr) {
      this.selectedFonts = this.selectedFonts.filter((o, i) => itr !== i)
    },
    requestFont () {
      if (!this.reqFont || this.reqFont === '') {
        this.errors.fonts = 'Request Font Name cannot be empty'
        return
      }
      this.startLoading()
      let data = {
        name: this.reqFont
      }
      this.addSingleFont(data).then((response) => {
        this.reqFont = null
        this.finishLoading()
        this.addNotification('success', 'Request Submitted Successfully')
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    back () {
      if ((this.subStep === 0) || (this.subStep === 1)) {
        this.step = parseInt(this.step)
      } else {
        this.subStep -= 1
        this.step = Number((this.step - 0.1).toFixed(1))
      }
    },
    showBack () {
      return this.step > 2 && this.step < 3
    }
  }
}
</script>

<style lang="scss">
.composition-block {
  display: flex;
  align-items: flex-end;
  button {
    height: 40px;
    margin-left: 20px;
  }
  .field{ width: 80%}
  .dropdown{ width: 80%}
  .form-control{height: 39px;}
}

.composition-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.3em;
  p {
    margin-bottom: 0;
  }
  i {
    color: #DC3545;
  }
}
.variable-element {
  margin-top: 10px;
  .field {
    margin-right: 10px;
  }
  .control-label{
    font-weight: normal;font-size: 12px;
  }
  label{font-weight: normal; font-size: 12px;}
}
.variable-element-wrapper{
  label{font-weight: normal; font-size: 12px;}
}
.analysing-files{ height: 250px; line-height: 250px;}
.buttun-margin {
  margin-top: 1rem;
}
.step-listing{    display: flex;justify-content: space-between;    margin-bottom: 10px;}
.listing-wrapper{border-top: 1px solid #DEE2E6; padding-top: 8px;
  padding-bottom: 2px;}
.no-bordered{border: 0px;}
.nolisting-wrapper{border-top: 0px solid #DEE2E6;border-bottom: 0px solid #DEE2E6;    padding-top: 0px;
  padding-bottom: 0px;}
.margin-auto{
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/campaigns/modal-create-campaign.vue